import { socialImageMeta } from "@/lib/social-sharing";
import { createFileRoute } from "@tanstack/react-router";
import { Cop31NewsFeed } from "@/components/Cop31NewsFeed";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";
import { PageIntro, PageSection, MoreLink } from "@/components/site/page";

const SITE_URL = "https://akillisurdurulebilirlik.com";

export const Route = createFileRoute("/cop31-haber-arsivi")({
  component: Cop31NewsArchiveTr,
  head: () => ({
    meta: [
      { title: pageTitle("COP31 Haber Arşivi", "tr") },
      {
        name: "description",
        content:
          "COP31 Antalya 2026 ile ilgili ulusal ve akredite Türkçe yayınlarda çıkan haberlerin otomatik güncellenen arşivi.",
      },
      { property: "og:title", content: "COP31 Haber Arşivi" },
      {
        property: "og:description",
        content: "Ulusal ve akredite yayınlardan COP31 haber arşivi; her sabah güncellenir.",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `${SITE_URL}/cop31-haber-arsivi` },
      { property: "og:locale", content: "tr_TR" },
      { name: "twitter:title", content: "COP31 Haber Arşivi" },
      { name: "twitter:description", content: "Ulusal ve akredite yayınlardan COP31 haber arşivi; her sabah güncellenir." },
      ...socialImageMeta(),
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/cop31-haber-arsivi` },
      ...hreflangLinks("/cop31-haber-arsivi", "/cop31-news-archive"),
    ],
  }),
});

function Cop31NewsArchiveTr() {
  return (
    <>
      <PageIntro
        crumbs={[{ label: "COP31", to: "/cop31" }, { label: "Haber Arşivi" }]}
        kicker="Haber Arşivi"
        dot="bg-theme-planet"
        title="COP31 Haber Arşivi"
        lede="Yalnızca ulusal ve akredite yayınların (AA, TRT, Reuters, Bloomberg vb.) COP31 haberleri derlenir. Liste her sabah 08:00'de otomatik güncellenir."
      />

      <PageSection>
        <Cop31NewsFeed lang="tr" limit={200} offset={5} showArchiveLink={false} />
        <div className="mt-8">
          <MoreLink to="/cop31">COP31 Rehberi</MoreLink>
        </div>
      </PageSection>
    </>
  );
}
